import { render, staticRenderFns } from "./ProductAverageCostChangesModal.vue?vue&type=template&id=00aae025&scoped=true&"
import script from "./ProductAverageCostChangesModal.vue?vue&type=script&lang=js&"
export * from "./ProductAverageCostChangesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aae025",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00aae025')) {
      api.createRecord('00aae025', component.options)
    } else {
      api.reload('00aae025', component.options)
    }
    module.hot.accept("./ProductAverageCostChangesModal.vue?vue&type=template&id=00aae025&scoped=true&", function () {
      api.rerender('00aae025', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product-average-cost/components/ProductAverageCostChangesModal.vue"
export default component.exports